class OnBusDirective {
  constructor(eventBus) {
    this.eventBus = eventBus;
  }

  mounted(targetElement, binding) {
    const eventName = binding?.arg;
    const handler = binding?.value;

    if (!this.isValidEventName(eventName)) return;
    if (!this.isValidHandler(handler)) return;

    this.attach(targetElement, eventName, handler);
  }

  unmounted(targetElement) {
    this.detach(targetElement);
  }

  attach(targetElement, eventName, handler) {
    this.eventBus.on(eventName, handler);
    this.storeBindingOnElement(targetElement, eventName, handler);
  }

  detach(targetElement) {
    const binding = this.getBindingFromElement(targetElement);
    if (!binding) return;

    const { eventName, handler } = binding;
    this.eventBus.off(eventName, handler);
    this.clearBindingFromElement(targetElement);
  }

  storeBindingOnElement(element, eventName, handler) {
    element._eventBusBinding = { eventName, handler };
  }

  getBindingFromElement(element) {
    return element._eventBusBinding || null;
  }

  clearBindingFromElement(element) {
    delete element._eventBusBinding;
  }

  isValidHandler(handler) {
    return typeof handler === 'function';
  }

  isValidEventName(eventName) {
    return typeof eventName === 'string' && eventName.trim().length > 0;
  }
}

function createOnBusDirective(eventBus) {
  const directiveInstance = new OnBusDirective(eventBus);

  return {
    mounted: directiveInstance.mounted.bind(directiveInstance),
    unmounted: directiveInstance.unmounted.bind(directiveInstance)
  };
}

export { OnBusDirective, createOnBusDirective };
